import _ from "lodash";
import { serializeRestConnector } from "../../common/utils";
import { Analytics, API } from "aws-amplify";
import { ANALYTICS_EVENT } from "../../common/ApmlifyRecordEvents";
import { buildBot, triggerBotBuilding } from "./intentsActions";
import {
  FETCH_SUBSCRIPTIONS,
  FETCH_SUBSCRIPTION_ESTIMATE,
  FETCH_SUBSCRIPTION_PAYMENT_INTENT,
  FETCH_SUBSCRIPTION_CREATE,
  CLEAR_SUBSCRIPTION_ESTIMATE,
  CLEAR_SUBSCRIPTION_CREATE,
  FETCH_SUBSCRIPTION_ADDONS,
  FETCH_LICENSES,
  CLEAR_LICENSES_INFO
} from "./types";
import { isArrowFunctionExpression } from "@babel/types";
import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
const config = require("../../app_configuration").CONFIGURATION[environment];

const API_REQUEST_FIXED_PARAMS = {
  Version: config.RESPONSUM_API_VERSION,
  Api: config.RESPONSUM_API,
  AccountType: config.RESPONSUM_API_RESOURCE_TYPE.PRIVATE
};

export const getTenantInteractionCounters = params => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      data: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        site: config.CHARGEBEE_SITE,
        method: "getTenantInteractionCounters",
        params: params.params
      },
      ...API_REQUEST_FIXED_PARAMS
    }
  };
  // TODO API Call
  console.log("getTenantInteractionCounters API CALL request", data);
  let apiResponse = await API.post(config.AWS_API_NAME, "subscriptions", data);
  console.log("getTenantInteractionCounters API CALL Response", apiResponse);
  return apiResponse;
};

export const getExternalChatbotStatus = params => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      data: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        site: config.CHARGEBEE_SITE,
        method: "hasConfiguredChatbot",
        params: params.params
      },
      ...API_REQUEST_FIXED_PARAMS
    }
  };

  // TODO API Call
  console.log("getExternalChatbotStatus API CALL request", data);
  let apiResponse = await API.post(config.AWS_API_NAME, "subscriptions", data);
  console.log("getExternalChatbotStatus API CALL Response", apiResponse);
  if (apiResponse.hasChatbot) {
    let data = {
      body: {
        data: {
          AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
          site: config.CHARGEBEE_SITE,
          method: "hasExternalChatbot",
          params: params.params
        },
        ...API_REQUEST_FIXED_PARAMS
      }
    };
    console.log("hasExternalChatbot API CALL request", data);
    const apiResponse2 = await API.post(config.AWS_API_NAME, "subscriptions", data);
    console.log("hasExternalChatbot API CALL Response", apiResponse2);
    apiResponse = { ...apiResponse, ...apiResponse2 };
  }
  return apiResponse;
};

export const clearTransactionInfo = params => async (dispatch, getState) => {
  // console.log("CLEAR_SUBSCRIPTION_CREATE request");
  dispatch({
    type: CLEAR_SUBSCRIPTION_CREATE,
    payload: {}
  });
};

export const getOwnerInfo = params => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      data: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        site: config.CHARGEBEE_SITE,
        method: "getOwnerInfo",
        params: params.params
      },
      ...API_REQUEST_FIXED_PARAMS
    }
  };
  // TODO API Call
  console.log("getOwnerInfo API CALL request", data);
  const apiResponse = await API.post(config.AWS_API_NAME, "subscriptions", data);
  console.log("getOwnerInfo API CALL Response", apiResponse);
  return apiResponse;
};

export const clearLicensesInfo = params => async (dispatch, getState) => {
  // console.log("CLEAR_SUBSCRIPTION_CREATE request");
  dispatch({
    type: CLEAR_LICENSES_INFO,
    payload: {}
  });
};

export const changeUserLicense = params => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      data: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        site: config.CHARGEBEE_SITE,
        method: params.method,
        params: params.params
      },
      ...API_REQUEST_FIXED_PARAMS
    }
  };
  // TODO API Call
  console.log("changeUserLicense API CALL request", data);
  console.log("changeUserLicense API CALL request", JSON.stringify(data));
  const apiResponse = await API.post(config.AWS_API_NAME, "subscriptions", data);
  console.log("changeUserLicense API CALL Response", apiResponse);
  console.log("changeUserLicense API CALL Response", JSON.stringify(apiResponse));

  const response = {
    data: {
      license: apiResponse
    }
  };

  return apiResponse;
};

export const fetchLicenses = params => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      data: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        site: config.CHARGEBEE_SITE,
        method: params.method,
        params: params.params
      },
      ...API_REQUEST_FIXED_PARAMS
    }
  };
  // TODO API Call
  console.log("fetchLicenses API CALL request", data);
  console.log("fetchLicenses API CALL request", JSON.stringify(data));
  const apiResponse = await API.post(config.AWS_API_NAME, "subscriptions", data);
  console.log("fetchLicenses API CALL Response", apiResponse);
  console.log("fetchLicenses API CALL Response", JSON.stringify(apiResponse));

  const response = {
    data: {
      license: apiResponse
    }
  };

  dispatch({
    type: FETCH_LICENSES,
    payload: { license: response.data }
  });

  return apiResponse;
};

export const fetchSubscriptionCreate = params => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      // AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      // ApiCall: "SubscriptionCreate",
      data: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        site: config.CHARGEBEE_SITE,
        method: params.method,
        params: params.params
      },
      ...API_REQUEST_FIXED_PARAMS
    }
  };
  // TODO API Call
  console.log("fetchSubscriptionCreate API CALL request", data);
  console.log("fetchSubscriptionCreate API CALL request", JSON.stringify(data));
  const apiResponse = await API.post(config.AWS_API_NAME, "subscriptions", data);
  console.log("fetchSubscriptionCreate API CALL Response", apiResponse);
  console.log("fetchSubscriptionCreate API CALL Response", JSON.stringify(apiResponse));

  const response = {
    data: {
      transaction: apiResponse
    }
  };

  dispatch({
    type: FETCH_SUBSCRIPTION_CREATE,
    payload: { transaction: response.data }
  });

  return apiResponse;
};

export const fetchSubscriptionEstimate = params => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      // AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      // ApiCall: "Estimate",
      data: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        site: config.CHARGEBEE_SITE,
        method: params.method,
        params: params.params
      },
      ...API_REQUEST_FIXED_PARAMS
    }
  };
  // TODO API Call
  console.log("fetchSubscriptionEstimate API CALL request", data);
  console.log("fetchSubscriptionEstimate API CALL request", JSON.stringify(data));
  const apiResponse = await API.post(config.AWS_API_NAME, "subscriptions", data);
  console.log("fetchSubscriptionEstimate API CALL Response", apiResponse);
  console.log("fetchSubscriptionEstimate API CALL Response", JSON.stringify(apiResponse));

  const payload = {};
  if (apiResponse && !apiResponse.errorMessage) {
    payload.estimate = { estimate: apiResponse };
  } else {
    payload.estimateError = apiResponse;
  }
  // const response = {
  //   data: {
  //     estimate: apiResponse
  //   }
  // };
  const dispatchMessage = {
    type: FETCH_SUBSCRIPTION_ESTIMATE,
    payload: payload
  };

  dispatch(dispatchMessage);

  return dispatchMessage;
};

export const clearSubscriptionEstimate = params => (dispatch, getState) => {
  dispatch({
    type: CLEAR_SUBSCRIPTION_ESTIMATE,
    payload: {
      estimate: undefined,
      payment_intent: undefined
    }
  });
};

export const fetchPaymentIntentCreate = params => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      // AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      // ApiCall: "PaymentIntentCreate",
      data: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        site: config.CHARGEBEE_SITE,
        method: params.method,
        params: params.params
      },
      ...API_REQUEST_FIXED_PARAMS
    }
  };
  // TODO API Call
  // console.log("fetchPaymentIntentCreate API CALL request", data);
  const apiResponse = await API.post(config.AWS_API_NAME, "subscriptions", data);
  // console.log("fetchPaymentIntentCreate API CALL Response", apiResponse);

  const response = {
    data: {
      payment_intent: apiResponse
    }
  };

  dispatch({
    type: FETCH_SUBSCRIPTION_PAYMENT_INTENT,
    payload: { payment_intent: response.data }
  });
};

export const fetchAddons = params => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      data: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        site: config.CHARGEBEE_SITE,
        method: "addon_list",
        params: {}
      },
      ...API_REQUEST_FIXED_PARAMS
    }
  };
  // TODO API Call
  console.log("fetchAddons API CALL request", data);
  const apiResponse = await API.post(config.AWS_API_NAME, "subscriptions", data);
  console.log("fetchAddons API CALL Response", apiResponse);

  const response = {
    addons: apiResponse
  };

  dispatch({
    type: FETCH_SUBSCRIPTION_ADDONS,
    payload: { addons: response }
  });
};

export const fetchSubscriptions = () => async (dispatch, getState) => {
  const state = getState();
  let data = {
    queryStringParameters: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "FetchSubscriptions",
      site: config.CHARGEBEE_SITE
    }
  };
  // TODO API Call
  console.log("API CALL request", data);
  const apiResponse = await API.get(config.AWS_API_NAME, "subscriptions/plans", data);
  console.log("API CALL Response", apiResponse);

  const response = {
    data: {
      enabled: [],
      common: apiResponse
    }
  };

  dispatch({
    type: FETCH_SUBSCRIPTIONS,
    payload: { plans: response.data }
  });
};
